import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';
import ListShgc from '@/views/ListShgc.vue';
import ListProjects from '@/views/ListProjects.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '',
    redirect: {
      name: 'Home',
    },
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
  },
  {
    path: '/shadings',
    name: 'Shadings',
    component: ListShgc,
  },
  {
    path: '/projects',
    name: 'Projects',
    component: ListProjects,
  },
  {
    path: '/p/:projectSlug',
    name: 'ProjectParent',
    component: () => import('@/views/ProjectParent.vue'),
    children: [
      {
        path: '',
        redirect: {
          name: 'Step1',
        },
      },
      {
        path: 'step1',
        name: 'Step1',
        component: () => import('../components/steps/Step1.vue'),
      },
      // {
      //   path: '/step1',
      //   name: 'Step1',
      //   component: () => import('../components/steps/Step1.vue'),
      // },
      {
        path: 'step2',
        name: 'Step2',
        component: () => import('../components/steps/Step2.vue'),
      },
      {
        path: 'step3A',
        name: 'Step3A',
        component: () => import('../components/steps/Step3A.vue'),
      },
      {
        path: 'step3B',
        name: 'Step3B',
        component: () => import('../components/steps/Step3B.vue'),
      },
      {
        path: 'step3C',
        name: 'Step3C',
        component: () => import('../components/steps/Step3C.vue'),
      },
      {
        path: 'step4',
        name: 'Step4',
        component: () => import('../components/steps/Step4.vue'),
      },
      {
        path: 'step5A',
        name: 'Step5A',
        component: () => import('../components/steps/Step5A.vue'),
      },
      {
        path: 'step5B',
        name: 'Step5B',
        component: () => import('../components/steps/Step5B.vue'),
      },
      {
        path: 'retv6A',
        name: 'Retv6A',
        component: () => import('../components/steps/Retv6A.vue'),
      },
      {
        path: 'retv6B',
        name: 'Retv6B',
        component: () => import('../components/steps/Retv6B.vue'),
      },
      {
        path: 'retv6C',
        name: 'Retv6C',
        component: () => import('../components/steps/Retv6C.vue'),
      },
      {
        path: 'result',
        name: 'Result',
        component: () => import('../components/Result.vue'),
      },
    ],
  },
  {
    path: '/overallresult',
    name: 'OverallResult',
    component: () => import('../components/OverallResult.vue'),
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

export default router;
